export const FETCH_PAYMENT_METHOD_AUTHORIZATION_TOKEN_REQUEST =
  'FETCH_PAYMENT_METHOD_AUTHORIZATION_TOKEN_REQUEST';
export const FETCH_PAYMENT_METHOD_AUTHORIZATION_TOKEN_SUCCESS =
  'FETCH_PAYMENT_METHOD_AUTHORIZATION_TOKEN_SUCCESS';
export const FETCH_PAYMENT_METHOD_AUTHORIZATION_TOKEN_FAILURE =
  'FETCH_PAYMENT_METHOD_AUTHORIZATION_TOKEN_FAILURE';

export const UPDATE_PAYMENT_METHOD_REQUEST = 'UPDATE_PAYMENT_METHOD_REQUEST';
export const UPDATE_PAYMENT_METHOD_SUCCESS = 'UPDATE_PAYMENT_METHOD_SUCCESS';
export const UPDATE_PAYMENT_METHOD_FAILURE = 'UPDATE_PAYMENT_METHOD_FAILURE';

export const fetchPaymentMethodAuthorizationTokenRequest = () => ({
  type: FETCH_PAYMENT_METHOD_AUTHORIZATION_TOKEN_REQUEST
});

export const fetchPaymentMethodAuthorizationTokenSuccess = token => ({
  type: FETCH_PAYMENT_METHOD_AUTHORIZATION_TOKEN_SUCCESS,
  payload: token
});

export const fetchPaymentMethodAuthorizationTokenFailure = err => ({
  type: FETCH_PAYMENT_METHOD_AUTHORIZATION_TOKEN_FAILURE,
  payload: err,
  error: true
});

export const updatePaymentMethodRequest = (authorizationToken, nonce) => ({
  type: UPDATE_PAYMENT_METHOD_REQUEST,
  payload: { authorizationToken, nonce }
});

export const updatePaymentMethodSuccess = token => ({
  type: UPDATE_PAYMENT_METHOD_SUCCESS
});

export const updatePaymentMethodFailure = err => ({
  type: UPDATE_PAYMENT_METHOD_FAILURE,
  payload: err,
  error: true
});



// WEBPACK FOOTER //
// ./src/store/paymentMethods/actions.js